import { render, staticRenderFns } from "./SendWithdrawal.vue?vue&type=template&id=18f650c2&scoped=true"
import script from "./SendWithdrawal.vue?vue&type=script&lang=js"
export * from "./SendWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f650c2",
  null
  
)

export default component.exports